import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from "../components/card";
import SearchBox from "../components/searchBox";
import Dropdown from "../components/dropdown";

export default function HomePage() {
  // const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectInput, setSelectInput] = useState("");
  const regionList = ["", "Africa", "Americas", "Asia", "Europe", "Oceania"];
  let navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    fetch("https://restcountries.com/v3.1/all")
      .then((res) => res.json())
      .then((results) => {
        // setIsLoaded(true);
        setItems(results);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleCardClick = ({ currentTarget: input }) => {
    navigate(`/detail/${data[input.id].name.common}`);
  };

  const handleSearch = ({ target: input }) => {
    setSearchInput(input.value.toLowerCase());
  };

  const handleSelect = ({ target: input }) => {
    setSelectInput(input.value);
  };

  const generateData = () => {
    //let filtered = items;
    const filtered = searchInput
      ? items.filter((item) =>
          item.name.common.toLowerCase().includes(searchInput)
        )
      : items;

    return selectInput
      ? filtered.filter((item) => item.region === selectInput)
      : filtered;
  };

  const data = generateData();

  return (
    <main className="homepage">
      <div className="homepage-container">
        <section className="toolbar">
          <SearchBox onChange={handleSearch} value={searchInput} />
          <Dropdown
            onChange={handleSelect}
            value={selectInput}
            options={regionList}
          />
        </section>
        <section className="homepage-main grid">
          {data.map((item, index) => (
            <Card
              key={index}
              id={index}
              name={item.name.common}
              flag={item.flags.svg}
              region={item.region}
              population={item.population}
              capital={item.capital}
              onClick={handleCardClick}
            />
          ))}
        </section>
      </div>
    </main>
  );
}
